"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var adPlacements_1 = require("../ads-growth/ads-service/config/adPlacements");
var isAdvertiserSafe_1 = __importDefault(require("./isAdvertiserSafe"));
var shouldShowAd = function (adEligibility, placement, testGroups, context) {
    // if ad eligibility is false, do not show ads
    if (!adEligibility.eligibility) {
        return { result: false, reason: "skipped_ad_eligibility" };
    }
    // Temp Fix due to inconsistencies
    // the story details page allows the hardcoded creative ad on mature stories
    // while other placements do not allow any ads on mature stories
    var storyLandingPlacements = [
        adPlacements_1.adPlacements.STORY_LANDING_TOP,
        adPlacements_1.adPlacements.STORY_LANDING_BOTTOM,
        adPlacements_1.adPlacements.STORY_LANDING_BOTTOM_MWEB,
    ];
    if (!storyLandingPlacements.includes(placement)) {
        var adSafe = (0, isAdvertiserSafe_1.default)(placement, testGroups, context);
        if (!adSafe.result) {
            return {
                result: false,
                reason: adSafe.reason,
            };
        }
    }
    return { result: true, reason: "passes_all_rules" };
};
exports.default = shouldShowAd;
